import React, { Component } from 'react';
import GridContainer from 'components/Grid/GridContainer';
import { dominioDemandaCirurgica } from '../../config/database';
import 'assets/css/minha-agenda.css';
import 'primeicons/primeicons.css';
import SalasCalendar from 'components/SalasCalendar/SalasCalendar';
import { Table, TableRow, TableCell, TableContainer, Select, MenuItem, InputLabel, FormControl, OutlinedInput, IconButton } from '@material-ui/core';
import GridItem from 'components/Grid/GridItem';
import { Calendar } from 'primereact/calendar';
import DeleteIcon from "@material-ui/icons/Delete";
import { Dialog as DialogPrime } from 'primereact/dialog';

class MapaDeSalas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataCirurgia: new Date(),
      salas: [],
      opcoesCentroCirurgico: [],
      centroCirurgicoFiltrado: [],
      equipes: [],
      equipesSelecionadas: [],
      calendarKey: 0,
      pedidoSelecionado: [],
      abreModal: false,
      profissional: JSON.parse(localStorage.getItem('profissional')),
    };
  }
  //#region Limpeza local Storage 
  limparLocalStoragePedido = () => {
    localStorage.setItem('activeStep', '0');
    localStorage.removeItem('convenio');
    localStorage.removeItem('peso');
    localStorage.removeItem('completed');
    localStorage.removeItem('paciente');
    localStorage.removeItem('dadosSolicitacao');
    localStorage.removeItem('faa');
    localStorage.removeItem('atendimento');
    localStorage.removeItem('data_atendimento');
    localStorage.removeItem('seq_atendimento');
    localStorage.removeItem('carater');
    localStorage.removeItem('profissionalResponsavel');
    localStorage.removeItem('dataSugerida');
    localStorage.removeItem('centroCirurgico');
    localStorage.removeItem('lateralidade');
    localStorage.removeItem('indicacaoClinica');
    localStorage.removeItem('prioridade');
    localStorage.removeItem('cidPrincipal');
    localStorage.removeItem('cidsSecundarios');
    localStorage.removeItem('tipoAcomodacao');
    localStorage.removeItem('diariasPrevistas');
    localStorage.removeItem('leitoUTI');
    localStorage.removeItem('tipoAnestesia');
    localStorage.removeItem('caixasOPME');
    localStorage.removeItem('materiaisConsumiveis');
    localStorage.removeItem('caixasCirurgicas');
    localStorage.removeItem('hemoderivados');
    localStorage.removeItem('procedimentoPrincipal');
    localStorage.removeItem('procedimentosSecundarios');
    localStorage.removeItem('documentos');
    localStorage.removeItem('pedidoCirurgia');
    localStorage.removeItem('equipamentos');
    localStorage.removeItem('duracaoEstimada');
    localStorage.removeItem('email');
    localStorage.removeItem('celular');
    localStorage.removeItem('telefone');
    localStorage.removeItem('exames');
    localStorage.removeItem('dataInternacao');
    localStorage.removeItem('motivoAntecipacaoInternacao');
    localStorage.removeItem('avaliacaoAnestesica');
    localStorage.removeItem('motivoAvaliacaoAnestesica');
    localStorage.removeItem('modalidadeAtendimento');
    localStorage.removeItem('novoPaciente');
    localStorage.removeItem('tipoPedido');
    localStorage.removeItem('centroCirurgicoPermitido');
    localStorage.removeItem('caraterAtendimentoPermitido');
    localStorage.removeItem('lateralidadePermitida');
    localStorage.removeItem('cidPrincipalPermitido');
    localStorage.removeItem('cidSecundarioPermitido');
    localStorage.removeItem('tipoAcomodacaoPermitido');
    localStorage.removeItem('motivoAntecipacaoPermitido');
    localStorage.removeItem('tipoAnestesiaPadrao');
    localStorage.removeItem('procedimentoPrincipalPermitido');
    localStorage.removeItem('procedimentoSecundarioPermitido');
    localStorage.removeItem('caixaOPMEPermitida');
    localStorage.removeItem('materialConsumivelPermitido');
    localStorage.removeItem('caixaCirurgicaPermitida');
    localStorage.removeItem('hemocomponentePermitido');
    localStorage.removeItem('equipamentoPermitido');
    localStorage.removeItem('pedidoCirurgiaVemDoModelo');
    localStorage.removeItem('salaCirurgia');
    localStorage.removeItem('demandaId');
    localStorage.removeItem('listaModalidadeAtendimento');
  };
  //#endregion
  //#region Renders
  renderOpcoesCentroCirurgico = () => {
    if (this.state.profissional.centrosCirurgicos.length <= 1) {
      this.setState({
        opcoesCentroCirurgico: [],
      });
      return;
    }

    const opcoes = [];
    dominioDemandaCirurgica.get('/api/centroCirurgico').then(response => {
      response.data.forEach(centroCirurgico => {
        if (this.state.profissional.centrosCirurgicos.includes(centroCirurgico.id))
          opcoes.push({
            id: centroCirurgico.id,
            departamento: centroCirurgico.departamento,
          });
      });
      this.setState({
        opcoesCentroCirurgico: opcoes,
      });
    });
  };

  renderEquipesAtivas = () => {
    const equipes = [];
    dominioDemandaCirurgica.get('/api/equipesAtivas').then(response => {
      response.data.forEach(equipe => {
        const desc = equipe.descricao + ' - ' + equipe.codigo
        equipes.push({
          id: equipe.id,
          descricao: desc
        });
      });
      this.setState({
        equipes: equipes,
      });
    });
  };

  renderHeaderDialogPedido = () => {
    return (
      <div className="div-header-dialog-pedido">
        <p>
          <strong>Pedido nº {this.state.pedidoSelecionado.id}</strong>
        </p>
      </div>
    );
  };

  renderCalendario = (salas, data, equipes, keyGlobal) => {
    let larguraSalas = window.outerWidth > 767 ? '13vw' : '200px';

    return (
      <TableRow>
        {salas.map((sala) => (
          <TableCell style={{ padding: '16px 2px', minWidth: larguraSalas }} item>
            {sala.descricao}
            <SalasCalendar id="calendarioSalas" key={keyGlobal} click={this.handleEventClick} sala={sala.id} dataCirurgia={data} equipesSelecionadas={equipes} />
          </TableCell>
        ))}
        <TableCell style={{ padding: '16px 2px', minWidth: '1000px' }} item>
          URGÊNCIA
          <SalasCalendar id="calendarioSalas" key={keyGlobal} click={this.handleEventClick} centroCirurgico={this.state.centroCirurgicoFiltrado} dataCirurgia={data} equipesSelecionadas={equipes} />
        </TableCell>
      </TableRow>)
  };

  async listarSalasCirurgicas(centroCirurgicoFiltrado) {
    let url = '';
    url = `api/salasCirurgicas/${centroCirurgicoFiltrado}`;
    await dominioDemandaCirurgica.get(url).then(response => {
      this.setState({
        salas: response.data.map(sala => {
          return {
            id: sala.id,
            descricao: sala.descricao,
            centroCirurgico: sala.centroCirurgico.descricao,
          };
        }),
      });
    });
    this.handleCalendarKey();
  }
  //#endregion
  //#region handles
  handleCalendarKey = () => {
    let { calendarKey } = this.state;
    calendarKey = Math.random();
    this.setState({ calendarKey });
  }

  handleDatachange(data) {
    this.setState({ dataCirurgia: data })
    this.listarSalasCirurgicas(this.state.centroCirurgicoFiltrado);
  }

  handleClickBotaoCentroCirurgico = centroCirurgico_id => {
    let { centroCirurgicoFiltrado } = this.state;
    centroCirurgicoFiltrado[0] = centroCirurgico_id;
    this.setState({ centroCirurgicoFiltrado });
    this.listarSalasCirurgicas(this.state.centroCirurgicoFiltrado);
  };

  handleEspecialidade = especialidade_id => {
    let { equipesSelecionadas } = this.state;
    equipesSelecionadas = especialidade_id
    this.setState({ equipesSelecionadas });
    this.listarSalasCirurgicas(this.state.centroCirurgicoFiltrado);
  }

  handleClickDelete = () => {
    let { equipesSelecionadas } = this.state;
    equipesSelecionadas = []
    this.setState({ equipesSelecionadas });
    this.listarSalasCirurgicas(this.state.centroCirurgicoFiltrado);
  }

  handleEventClick = info => {
    let { abreModal, pedidoSelecionado } = this.state;
    abreModal = true;
    pedidoSelecionado = info.event;
    if (info.event.extendedProps.isTempoSetup === false) {
      this.setState({ abreModal, pedidoSelecionado })
    }
  };
  //#endregion

  componentDidMount() {
    this.handleCalendarKey();
    this.renderOpcoesCentroCirurgico();
    this.renderEquipesAtivas();
    this.listarSalasCirurgicas(this.state.centroCirurgicoFiltrado);
  }

  render() {
    //#region regionalização do calendário
    const pt = {
      firstDayOfWeek: 1,
      dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
      dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
      dayNamesMin: ['DO', 'SE', 'TE', 'QA', 'QI', 'SX', 'SA'],
      monthNames: [
        'janeiro',
        'fevereiro',
        'março',
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro',
      ],
      monthNamesShort: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez',
      ],
      today: 'Hoje',
      clear: 'Limpar',
      dateFormat: 'dd/mm/yy',
      weekHeader: 'Sm',
    };
    //#endregion
    return (
      <div>
        <DialogPrime
          header={this.renderHeaderDialogPedido()}
          visible={this.state.abreModal}
          onHide={() =>
            this.setState({
              abreModal: false
            })
          }
          style={{ width: '45vw' }}
        >
          <div style={{ width: '40vw' }}>
            <div>
              <strong>Paciente:</strong>  {this.state.pedidoSelecionado?.extendedProps?.paciente}
            </div>
            <hr style={{ marginBlock: '10px' }} />
            <div>
              <strong>Requisitante:</strong>  {this.state.pedidoSelecionado?.extendedProps?.profissional}
            </div>
            <hr style={{ marginBlock: '10px' }} />
            <div>
              <strong>Procedimento principal:</strong>  {this.state.pedidoSelecionado?.extendedProps?.procedimento}
            </div>
          </div>
        </DialogPrime>
        <div>
          <GridContainer>
            <InputLabel style={{ paddingLeft: 30, paddingBottom: 2 }}>DATA CIRURGIA</InputLabel>
          </GridContainer>
          <GridContainer>
            <GridItem>
              <Calendar
                locale={pt}
                dateFormat="dd/mm/yy"
                value={this.state.dataCirurgia}
                onChange={(event) => this.handleDatachange(event.target.value)}
                showIcon
                showButtonBar
                style={{
                  paddingLeft: 10,
                  height: '5.6vh',
                  width: '10vw'
                }}
              />
            </GridItem>
            <GridItem>
              <FormControl variant="outlined">
                <InputLabel>CENTRO CIRÚRGICO</InputLabel>
                <Select
                  style={{
                    width: '20vw',
                    height: '5.6vh',
                    backgroundColor: '#FFF'
                  }}
                  onChange={(event) => this.handleClickBotaoCentroCirurgico(event.target.value)}
                  input={<OutlinedInput label="CENTRO CIRÚRGICO" />}
                >
                  {this.state.opcoesCentroCirurgico.map(botao => (
                    <MenuItem value={botao.id}>{botao.departamento}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </GridItem>
            <GridItem>
              <FormControl variant="outlined">
                <InputLabel>ESPECIALIDADE</InputLabel>
                <Select style={{
                  width: '20vw',
                  height: '5.6vh',
                  backgroundColor: '#FFF'
                }}
                  multiple
                  value={this.state.equipesSelecionadas}
                  onChange={(event) => this.handleEspecialidade(event.target.value)}
                  input={<OutlinedInput label="ESPECIALIDADE" />}
                  renderValue={(selected) => selected.join(', ')}
                >
                  {this.state.equipes.map((equipe) => (
                    <MenuItem value={equipe.id}>
                      {equipe.descricao}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <IconButton
                aria-label='delete'
                onClick={this.handleClickDelete}>
                <DeleteIcon />
              </IconButton>
            </GridItem>
          </GridContainer>
        </div>
        <div style={{
          padding: '16px',
          height: '80vh'
        }}>
          <GridContainer justify="left" id="SalasCirurgicas">
            <TableContainer style={{ width: '100%', height: '80vh', overflowX: 'auto', borderRadius: '10px' }}>
              <Table xs={12} sm={12} md={11}>
                {this.renderCalendario(this.state.salas, this.state.dataCirurgia, this.state.equipesSelecionadas, this.state.calendarKey)}
              </Table>
            </TableContainer>
          </GridContainer>
        </div>
      </div>
    );
  }
}
export default MapaDeSalas;
